import { useQuery, gql } from "@apollo/client"

const useAllGlobalVars = (variables = {}) => {
    const {data, loading, refetch} = useQuery(
        gql`
            query {
                getAllGlobalVars {
                    name
                    id
                    type
                }
            }
        `, 
        {
            variables,
            fetchPolicy: 'no-cache'
        }
    )

    return {data: data ? data.getAllGlobalVars : [], loading, refetch}
}

export default useAllGlobalVars